export interface ConfigState {
    website_session_timeout: number;
    website_session_remember_me_timeout: number;
    website_sensitive_area_timeout: number;
    website_device_cookie_timeout: number;
    website_login_redirect_domain_whitelist: string[];
    website_2fa_methods: string[];
    website_2fa_email_resend_code_timeout: number;
    website_google_recaptcha_v2_site_key: string;
    website_sms_resend_code_timeout: number;
    website_faq_translate_tag_id: number;
    website_google_tag_id: string;
    usa_taxable_honoraria: boolean;
    short_cookie_name: string;
    website_registration_disabled_profession_ids: number[];
    registration_relevantid_survey_id?: string;
}

export const initialConfigState: ConfigState = {
    website_session_timeout: 86400,
    website_session_remember_me_timeout: 604800,
    website_sensitive_area_timeout: 3600,
    website_device_cookie_timeout: 31536000,
    website_login_redirect_domain_whitelist: [],
    website_2fa_methods: ['EMAIL'],
    website_2fa_email_resend_code_timeout: 120,
    website_google_recaptcha_v2_site_key: '',
    website_sms_resend_code_timeout: 120,
    website_faq_translate_tag_id: 30,
    website_google_tag_id: '',
    usa_taxable_honoraria: false,
    short_cookie_name: '',
    website_registration_disabled_profession_ids: [],
    registration_relevantid_survey_id: 'REGISTRATION',
};
